const checkSpecialCharsAndEmpty = (value) => {
  const thisValue = value.toString().toLowerCase();
  let hasSpecialChars = false;
  if (typeof value === 'string') {
    hasSpecialChars =
      thisValue.includes('\n') ||
      thisValue.includes('\t') ||
      thisValue.includes(',') ||
      thisValue.includes(';') ||
      thisValue.includes('.') ||
      thisValue.includes('"') ||
      thisValue.includes("'") ||
      thisValue.includes('`') ||
      thisValue.includes('´') ||
      thisValue.includes(' ') ||
      thisValue.length === 0;
  }

  return hasSpecialChars;
};
const escapeDoubleQuotesInsideElement = (element) => {
  const thisElement = element.replace(/"/g, '""');

  return thisElement;
};

const replaceExcelMacros = (content) => {
  const charsArr = ['=', '-', '\\+', '@'];
  const patternsArr = [',x', '\nx', '\n"x', ',"x'];
  const charReplace = (str, char) => {
    return patternsArr.reduce((accumulation, pattern) => {
      const replaceVal = new RegExp(pattern.replace('x', char), 'g');
      const replaceBy = pattern.replace('x', `\\${char.slice(-1)}`);
      return accumulation.replace(replaceVal, replaceBy);
    }, str);
  };
  return charsArr.reduce((accumulatedContent, char) => {
    return charReplace(accumulatedContent, char);
  }, content);
};

export const downloadFile = (content, fileName, mimeType) => {
  const a = document.createElement('a');
  mimeType = mimeType || 'application/octet-stream';
  const sanitizedContent = replaceExcelMacros(content);

  if (navigator.msSaveBlob) {
    // IE10
    return navigator.msSaveBlob(new Blob([sanitizedContent], { type: mimeType }), fileName);
  }
  if ('download' in a) {
    // html5 A[download]
    a.href = `data:${mimeType},${encodeURIComponent(sanitizedContent)}`;
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return true;
  }

  return false;
};

export const downloadBlob = (blob, fileName) => {
  const a = document.createElement('a');

  if (navigator && navigator.msSaveBlob) {
    // IE11
    return navigator.msSaveBlob(blob, fileName);
  }
  if ('download' in a) {
    // html5 A[download]
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    return true;
  }

  return false;
};

/**
 * @param mappingOfObjectKeys
 * @param {string} mappingOfObjectKeys.key
 * @param {string} [mappingOfObjectKeys.displayName] required if withTitle qual true
 * @param {function({item: *, key: *})=>string} [mappingOfObjectKeys.selector = (item,key) => item[key] || "" ]
 * @param {Array} dataArray
 * @param {boolean} [withTitle=true]
 * @return {string} csv content
 */
export const convertToCsvContent = (mappingOfObjectKeys, dataArray, withTitle = true) => {
  const titles = mappingOfObjectKeys.map(({ displayName }) => displayName);
  const initResult = withTitle ? [titles] : [];
  const rows = initResult.concat(
    dataArray.map((object) =>
      mappingOfObjectKeys.map(({ key, selector }) => {
        const value = escapeDoubleQuotesInsideElement(selector(object, key));
        const isIncludesSpecials = checkSpecialCharsAndEmpty(value);
        return isIncludesSpecials ? `"${value}"` : `${value}`;
      })
    )
  );
  const result = rows.map((e) => e.join(',')).join('\n');
  return result;
};
